export const queryDefaults = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity,
      keepPreviousData: true,
    },
  },
};

export const emptyResults = {
  entries: [],
  meta: { links: {}, total_count: 0 },
};
